export default function Error({ error }) {
  return (
    <section className="w-100 text-center my-5">
      <h2 className="text-danger">Something went wrong.</h2>
      <p className="mt-4 fw-bold">It might be due to :</p>
      <pre>{JSON.stringify(error)}</pre>
    </section>
  );
}
